export default __webpack_public_path__ + "static/media/User1.4a432168.jpg";